export default function Footer() {
  return (
    <footer className="footer">
      <span>
        © 2026 Asepsis Pty Ltd. All rights reserved. Powered by Asepsis.
        <img src="/img/asespsis_icon.png" width={20} style={{ marginLeft: "10px" }} />
      </span>
    </footer>
  );
}
